import './comparePopin.css';

export class ComparePopin {
  selector = '.js-dialog';
  openTrigger = '.js-dialog-open';
  closeTrigger = '.js-dialog-close';
  _dialog;
  lastScrollPosition = 0;

  constructor(selector) {
    this.selector = selector ?? this.selector;

    this._dialog = $(this.selector);

    // Click outside popin (backdrop) => close
    $(document).on('click', this.selector, (e) => {
      e.preventDefault();
      this._dialog = $(this.selector)[0];
      const rect = $(this.selector)[0].getBoundingClientRect();
      const isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height &&
        rect.left <= e.clientX && e.clientX <= rect.left + rect.width);
      if (!isInDialog) {
        this.close();
      }
    });

    $(document).on('click', this.openTrigger, (e) => {
      e.preventDefault();
      this.open();
    });

    $(document).on('click', this.closeTrigger, (e) => {
      e.preventDefault();
      this.close();
    });

    return this;
  }

  open() {
    // Save the current scroll position before opening compare popin
    this.lastScrollPosition = window.scrollY;
    $(this.selector)[0].showModal();
  }

  close() {
    $(this.selector)[0].close();
    // Scroll to the saved position when closing the popin
    window.scrollTo(0, this.lastScrollPosition);
  }
}